$(document).ready(function() {
	let rootPath = window.location.protocol + '//' + window.location.hostname + '/';
	$('.navbar .dropdown > a').click(function() {
		if (!$(this).hasClass("parent-clicked")) {
			$(this).addClass("parent-clicked");
		} else {
			$(this).removeClass('parent-clicked');
			if (this.href !== rootPath) {
				location.href = this.href;
			}
		}
	});
	$('.dropdown-toggle').blur(function() {
		$(this).removeClass('parent-clicked');
	})
});